import { nextTransitionMessage, prevTransitionMessage } from "../../modules/carousel/carousel_helper";

const CarouselEventHandlers = {

  // Event handler for previous and next buttons
  changeSlide (options) {
    let slideOffset, targetSlide;

    if (this.props.carouselWrapAround) {
      slideOffset = this.props.carouselSlidesToScroll;
    } else {
      if (options.message === nextTransitionMessage) {
        if (this.getState().currentSlide + this.props.carouselSlidesToShow + this.props.carouselSlidesToScroll <= this.getState().slideCount) {
          slideOffset = this.props.carouselSlidesToScroll;
        } else {
          slideOffset = this.getState().slideCount - this.getState().currentSlide - this.props.carouselSlidesToShow;
        }
      } else if (options.message === prevTransitionMessage) {
        if (this.getState().currentSlide - this.props.carouselSlidesToScroll >= 0) {
          slideOffset = this.props.carouselSlidesToScroll;
        } else {
          slideOffset = this.getState().currentSlide;
        }
      }
    }
    if (options.message === prevTransitionMessage) {
      targetSlide = this.getState().currentSlide - slideOffset;

    } else if (options.message === nextTransitionMessage) {
      targetSlide = this.getState().currentSlide + slideOffset;
    }
    this.slideHandler(targetSlide);
  },

  swipeStart (e) {
    let posX, posY;
    posX = (e.touches !== undefined) ? e.touches[0].clientX : e.clientX;
    posY = (e.touches !== undefined) ? e.touches[0].clientY : e.clientY;
    const changedState = {
      swiping: true,
      touchObject: {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY,
      },
    };
    this.setState({
      carouselStore: Object.assign({}, this.getState(), changedState),
    });
  },

  swipeEnd (e) {
    if (!this.getState().swiping) {
      return;
    }
    const touchObject = this.getState().touchObject;
    let posX, posY;
    posX = (e.changedTouches !== undefined) ? e.changedTouches[0].clientX : e.clientX;
    posY = (e.changedTouches !== undefined) ? e.changedTouches[0].clientY : e.clientY;
    touchObject.curX = posX;
    touchObject.curY = posY;
    const swipeDirection = this.swipeDirection(touchObject);
    const minSwipe = this.getState().carouselSlidesToShow > 2 ? this.getState().listWidth / this.getState().carouselSlidesToShow : this.getState().listWidth /4;
    const swipeXLength = Math.abs(touchObject.curX - touchObject.startX);
    // reset the state of touch related state variables.
    const changedState = {
      swiping: false,
      touchObject: {},
    };
    this.setState({
      carouselStore: Object.assign({}, this.getState(), changedState),
    });
    if (!swipeXLength) {
      return;
    }
    if (swipeXLength > minSwipe) {
      e.preventDefault();
      if (swipeDirection === "left") {
        this.changeSlide({ message: nextTransitionMessage });
      } else if (swipeDirection === "right") {
        this.changeSlide({ message: prevTransitionMessage });
      } else {
        return;
      }
    }
  },

  swipeDirection (touchObject) {
    let xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if ((swipeAngle <= 45) && (swipeAngle >= 0) || (swipeAngle <= 360) && (swipeAngle >= 315)) {
      return "left";
    }
    if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
      return "right";
    }
    return "vertical";
  },
};

export default CarouselEventHandlers;
